import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ac6a20e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-actions" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "H", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("1")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "H", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("2")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "H", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("3")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import HeadingBlock from "./HeadingBlock";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeadingConfig',
  props: {
    getBlock: null
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as {
	getBlock: () => HeadingBlock;
}





function setSize(size: 1 | 2 | 3) {
	props.getBlock().size = size;
	emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (setSize(1)))
    }, _hoisted_4),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (setSize(2)))
    }, _hoisted_7),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (setSize(3)))
    }, _hoisted_10)
  ]))
}
}

})